import React, { useEffect, useState } from 'react'
import { APPLICATION_JSON } from '../../middleware/types';
import FormField from './FormField'
import Helper from '../Helper';
import './FormPlugin.scss'
import useStateRef from 'react-usestateref';
import { useHistory } from 'react-router-dom';
import formJson from './FormTemplateJson.json'

const FormTemplatePlugin = ({ content, containerObject, templateName, contentId, dataZone }) => {
  // console.log("containerObject--------", containerObject)
  const [successMsg, setSuccessMsg, successMsgRef] = useStateRef(false);
  const [errorMsg, setErrorMsg, errorMsgRef] = useStateRef(false);
  const [formSubmittedMsg, setFormSubmittedMsg, formSubmittedMsgRef] = useStateRef(false);
  const [formError, setFormError] = useState(false);
  const [formSuccess, setFormSuccess] = useState(false);
  const history = useHistory();
  const [reset,setReset, resetRef] = useStateRef(false)
  const showElements = new Map();
  const hideElements = new Map();

  const handleShowFields = (fieldName, fieldValue) => {
    // console.log("handleShowFields--------", fieldName, fieldValue)
    var showElementsMap = showElements.has(fieldName)
    if (showElementsMap) {
      // console.log("handleShowFields--------showElementsMapinsidee", showElementsMap)
      const fieldNameShowMap = showElements.get(fieldName)
      Array.from(fieldNameShowMap.entries()).map(([value, listOfFields]) => {
        if (fieldValue === value) {
          listOfFields.map((oneField) => {
            // console.log("getElementById----------iff", document.getElementById(oneField))
            document.getElementById(oneField).style.display = "block"
          })
        } else {
          listOfFields.map((oneField) => {
            // console.log("getElementById----------elsee", document.getElementById(oneField))
            document.getElementById(oneField).style.display = "none"
          })
        }
      })
    }
  }

  const handleHideFields = (fieldName, fieldValue) => {
    // console.log("handleHideFields--------", fieldName, fieldValue)
    var showElementsMap = hideElements.has(fieldName)
    // console.log("handleHideFields--------showElementsMapoutisdee", hideElements)
    if (showElementsMap) {
      const fieldNameHideMap = hideElements.get(fieldName)
      Array.from(fieldNameHideMap.entries()).map(([value, listOfFields]) => {
        if (fieldValue === value) {
          listOfFields.map((oneField) => {
            // console.log("handleHideFields--getElementById----------iff", document.getElementById(oneField))
            document.getElementById(oneField).style.display = "none"
          })
        } else {
          listOfFields.map((oneField) => {
            // console.log("handleHideFields--getElementById----------elsee", document.getElementById(oneField))
            document.getElementById(oneField).style.display = "block"
          })
        }
      })
    }
  }

  const labelMerger = (label) => {
    var mergedLabel = "";
    if (label.length != 0) {
      var splitedLabel = label.split(" ");

      if (splitedLabel) {
        splitedLabel.map((oneLabel) => {
          if (splitedLabel.indexOf(oneLabel) != 0) {
            if (oneLabel) {
              let firstLetterUpperCase = oneLabel[0].toUpperCase();
              let labelSubStr = oneLabel.substr(1, oneLabel.length - 1);
              oneLabel = firstLetterUpperCase + labelSubStr;
            }
          }

          mergedLabel += oneLabel;
        })
      }
    }
    return mergedLabel;
  }

  function validateForm(event) {
   event.preventDefault();
    var actionUrl = event.target.getAttribute('action');
    const data = new FormData(event.target)
    const value = Object.fromEntries(data.entries());
    const formId = containerObject.attributes.formId ? labelMerger(containerObject.attributes.formId) : '';
    const pageId = contentId;
    const formContentId = containerObject.contentId ? containerObject.contentId : '';
    Helper.clearErrorMsg(formId)
    var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
    fetch(`${Url}`, {
      credentials: 'include',
      method: containerObject.attributes.method,
      headers: new Headers({ "Content-Type": "application/json" }),
      body: JSON.stringify({
        formData: value,
        formId: formId,
        pageId: pageId,
        formContentId: formContentId,
      })
    }).then(res => res.json()).then(res => {
      if (res.result == "error") {
        setReset(true)
        Helper.errorMsgLoader(res.error, formId, "form-error-msg");
        if (res.error._ERROR_MESSAGE_) {
          setErrorMsg(res.error._ERROR_MESSAGE_)
          setFormError(true)
          document.getElementById("error-msg").style.display = "block"
          setTimeout(function () {
            document.getElementById("error-msg").style.display = "none"
          }, 3000)
        }
      } else {
        setReset(false)
        Helper.clearErrorMsg(formId)
        if(res.dataSubmittedMsg && res.dataSubmittedMsg._EVENT_MESSAGE_){
          // console.log("successMsg======",res.dataSubmittedMsg._EVENT_MESSAGE_)
          setSuccessMsg(res.dataSubmittedMsg._EVENT_MESSAGE_)
          setFormSubmittedMsg(res.dataSubmittedMsg._EVENT_MESSAGE_)
          document.getElementById("event-msg").style.display = "block"
        }
        else if (containerObject.attributes.SubmissionRedirectUrl && containerObject.attributes.SubmissionRedirectUrl !== "") {
            // console.log("SubmissionRedirectUrl======", containerObject.attributes.SubmissionRedirectUrl)
            history.push(`${containerObject.attributes.SubmissionRedirectUrl}`)
        } else {
          var successMsg = containerObject.attributes.SubmissionMessage ? containerObject.attributes.SubmissionMessage : "Thank you for filling out your information"
          // console.log("successMsg======",successMsg)
          setSuccessMsg(successMsg)
          setFormSuccess(true)
         
          document.getElementById("success-msg").style.display = "block"
          setTimeout(function () {
            document.getElementById("success-msg").style.display = "none"
          }, 3000)
        }
      }
    })
  }
  const [showModal, setShowModal] = useState(false);
  const openModal = () => {
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
  };

  function handleElementsEvent(contentValue, formLabel, elementsMap, mapType) {
    const key = contentValue[mapType];
    console.log("contentnetetete---key", mapType, key)
    var eventFieldToValue = key.split("::")
    var eventField = eventFieldToValue[0] //gender
    var triggerValue = eventFieldToValue[1] //M
    var checkFieldIsPresentInMap = elementsMap.has(eventField)
    if (checkFieldIsPresentInMap) {
      var eventFieldMap = elementsMap.get(eventField)
    }
    else {
      var eventFieldMap = new Map()
      elementsMap.set(eventField, eventFieldMap)
    }
    var affectedFields = eventFieldMap.get(triggerValue)
    if (affectedFields === undefined) {
      affectedFields = []
      eventFieldMap.set(triggerValue, affectedFields)
    }
    affectedFields.push(labelMerger(formLabel))
  }


  return (
    <>
      <div className='px-3'>
        <div style={{ textAlign: `${containerObject.attributes.formAlignment}` }}>
          {formSuccess ?
            <div id="success-msg" className="alert alert-success">
              <p>{successMsgRef.current}</p>
            </div>
            : ""}
          {formError ? <>
            <div id="error-msg" className="alert alert-danger">
              <strong><i class='fas fa-exclamation-circle'></i></strong>
              <span>  {errorMsgRef.current}</span>
            </div> </> : ""}

            {formSubmittedMsgRef.current && formSubmittedMsgRef.current ? 
            <div id="event-msg">
              <div>
                <img className="form-event-img" src="/cmsadminui/static-assets/ThankYou.jpg"/>
                <p className="form-event-message">{formSubmittedMsgRef.current}</p>
              </div>
            </div>
            : 
            <> 
            <span dangerouslySetInnerHTML={{ __html: containerObject.attributes.formTitle }}></span>
          
            <div className="d-flex" style={{ justifyContent: `${containerObject.attributes.formAlignment}` }}>

            <form style={{ width: "100%" }} id={labelMerger(containerObject.attributes.formId)} action={containerObject.attributes.SubmissionUrl}
                  className={`form-plugin ${containerObject.attributes && containerObject.attributes.class ? containerObject.attributes.class : ""}`} 
                  method={containerObject.attributes.formMethod} onSubmit={validateForm}>

              {containerObject.section && containerObject.section && Object.entries(containerObject.section).map(([key, sectionKey]) => {
                console.log("containerObject sectionKey-----", sectionKey)
                return (<>
                  <div className={`${sectionKey.attributes.sectionCss && sectionKey.attributes.sectionCss}`}>
                    {/* <span>{sectionKey.attributes.internalName}</span> */}
                    <span dangerouslySetInnerHTML={{ __html: sectionKey.attributes.sectionTitle }}></span>
                    <span dangerouslySetInnerHTML={{ __html: sectionKey.attributes.sectionBody }}></span>
                  </div>

                  {sectionKey.forms && Object.entries(sectionKey.forms).map(([key, field]) => {
                    console.log("containerObject sectionnn-----", field, field.attributes.event)
                    if (field.attributes && field.attributes.event && field.attributes.event !== "") {
                      const contentValue = JSON.parse(field.attributes.event)
                      // const contentValue = field.attributes.event
                      console.log("contentnetetete---aftet", contentValue, field.attributes.event, contentValue["show"])
                      if (contentValue["show"]) {
                        handleElementsEvent(contentValue, field.attributes.formLabel, showElements, "show")
                      }
                      if (contentValue["hide"]) {
                        handleElementsEvent(contentValue, field.attributes.formLabel, hideElements, "hide")
                      }
                    }
                    console.log("showElements===========field", showElements)
                    console.log("hideElements===========field", hideElements)
                    return (<>
                      <FormField
                        formObj={field}
                        type={field.attributes.formLabelType}
                        label={field.attributes.formLabel}
                        mandatoryField={field.attributes.mandatoryField}
                        formLabelWidth={field.attributes.formLabelWidth}
                        formLabelTypeWidth={field.attributes.formLabelTypeWidth}
                        uniqueField={field.attributes.uniqueField}
                        class={field.attributes.class}
                        optionsValue={field.attributes.optionsValue}
                        groupOfCheckBox={field.attributes.groupOfCheckBox}
                        groupOfRadioButton={field.attributes.groupOfRadioButton}
                        labelValue={field.attributes.formRichText ? field.attributes.formRichText : ""}
                        handleShowFields={handleShowFields}
                        handleHideFields={handleHideFields}
                        labelMerger={labelMerger}
                        event={field.attributes.event}
                        reset={resetRef?.current}
                      />
                    </>)
                  })}

                </>)
              })}



              {/* {formJson && formJson.forms.map((content, index) => {
                if (content && content.event) {
                  const contentValue = JSON.parse(content.event)
                  // console.log("contentnetetete---aftet",content.event,contentValue["show"])
                  if (contentValue["show"]) {
                    handleElementsEvent(contentValue, content.formLabel, showElements, "show")
                  }
                  if (contentValue["hide"]) {
                    handleElementsEvent(contentValue, content.formLabel, hideElements, "hide")
                  }
                }
                console.log("showElements===========", showElements)
                console.log("hideElements===========", hideElements)

                return (<>
                  <FormField
                    formObj={content}
                    type={content.formLabelType}
                    label={content.formLabel}
                    mandatoryField={content.mandatoryField}
                    formName={containerObject.formName}
                    formLabelWidth={content.formLabelWidth}
                    formLabelTypeWidth={content.formLabelTypeWidth}
                    uniqueField={content.uniqueField}
                    class={content.class}
                    optionsValue={content.optionsValue}
                    groupOfCheckBox={content.groupOfCheckBox}
                    groupOfRadioButton={content.groupOfRadioButton}
                    labelValue={content.formRichText ? content.formRichText : ""}
                    handleShowFields={handleShowFields}
                    handleHideFields={handleHideFields}
                    labelMerger={labelMerger}
                    event={content.event}
                  />
                </>)
              })}  */}




              <div className='col-12'>
                <span style={{ textAlign: 'center !important' }} id='_ERROR_MESSAGE_'></span>
              </div>
              <div style={{ textAlign: `${containerObject.attributes.formAlignment}` }} className='form-button' >
                <button className={`mb-2 form-btn ${containerObject.attributes && containerObject.attributes.buttonCss ? containerObject.attributes.buttonCss : ""}`}>{containerObject.attributes.submitName}</button>
              </div>
            </form>
          </div>
          </> }
        </div>
        {/* // } */}
      </div>
    </>
  )
}
export default FormTemplatePlugin

